import React from "react";
import SpecificationTable from "./SpecificationTable";
import { Box, Grid } from "@mui/material";

const Specification = ({ data }) => {
  return (
    <div>
      <Grid container spacing={2}>
        {data &&
          data?.specifications?.map((specs, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <SpecificationTable specs={specs} />
            </Grid>
          ))}
      </Grid>
    </div>
  );
};

export default Specification;
